import { SpaceXxs } from "@nxt-costco-com/forge-design-tokens";
const deliveryTextDivStyles = {
  display: "flex",
  flexDirection: "row",
  flexWrap: "wrap",
  gap: SpaceXxs
};
const iconSizeStyles = { height: 16, width: 16 };
export {
  deliveryTextDivStyles,
  iconSizeStyles
};
